import type { ComponentTheme } from '../types/component-theme';

import { progressChipLabelStyles, progressChipControlStyles } from '../shared-styles';

export default {
    slots: {
        root:
            'relative inline-flex items-center gap-[0.4rem] ' +
            progressChipControlStyles +
            ' transition-all duration-250 ease-in-out opacity-[0.52] shrink-0 ' +
            'not-disabled:hover:not-[.active]:bg-(--glass-surface-bg-50) ' +
            'not-disabled:hover:not-[.active]:opacity-[0.85] disabled:cursor-not-allowed',

        icon:
            'flex size-6 shrink-0 items-center justify-center rounded-[0.438rem] text-(--text-muted) ' +
            'bg-(--glass-surface-bg-50) border border-(--slate-strong-alpha-12) shadow-(--glass-inset-line-shadow) ' +
            'transition-all duration-250 ease-[ease]',
        lockedIcon: 'text-slate-400 dark:text-slate-500',
        doneIcon: 'text-white',
        label: progressChipLabelStyles
    },
    variants: {
        active: {
            true: {
                root:
                    'opacity-100 bg-(image:--accent-gradient) border-transparent translate-y-[-0.063rem] ' +
                    'shadow-(--accent-control-active-shadow) hover:opacity-100',

                icon:
                    'bg-(--white-alpha-12) text-(--pure-white)! border-(--white-alpha-18) ' +
                    'shadow-[0_0.125rem_0.5rem_var(--progress-glow),inset_0_0.063rem_0_rgba(255,255,255,0.25)] ' +
                    '[&_svg]:text-(--pure-white)! [&_svg]:fill-current',

                label: 'text-(--pure-white)! font-bold'
            }
        },
        done: {
            true: {
                root: 'opacity-[0.78]! cursor-pointer',

                icon:
                    'bg-(image:--accent-gradient) text-(--pure-white) border-transparent ' +
                    'shadow-(--progress-glow-shadow-2xs) opacity-[0.72] [&_svg]:text-(--pure-white) ' +
                    '[&_svg]:fill-current',

                label: 'text-(--text-light)'
            }
        },
        locked: {
            true: {
                root: 'opacity-[0.28]! cursor-not-allowed!',

                icon: 'bg-(--glass-surface-bg-50) text-(--text-muted) border-(--slate-strong-alpha-12) shadow-none',

                label: 'text-(--text-light)'
            }
        },
        partial: {
            true: {
                root: 'opacity-[0.72]',
                icon: 'text-(--accent-solid)'
            }
        }
    }
} satisfies ComponentTheme;
